import { useEffect, useMemo, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { Add } from "@mui/icons-material";
import { useSearchParams } from "react-router-dom";
// import LogoutContainer from "../../Layout/LogoutContainer";
import { HeaderStyle } from "../../Common/styles/header";
import UsersList from "./UsersList";
import { useAppSelector } from "../../../Redux/hooks";
import { platformAdminPermissions } from "../../../utils/roles";

const Users = () => {
  const { platformPermissions } = useAppSelector((state) => state.user);
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchText, setSearchText] = useState(searchParams.get("query") ?? "");
  const [showModal, setShowModal] = useState(false);
  const canEdit = useMemo(
    () => platformPermissions.includes(platformAdminPermissions.manageUser),
    [platformPermissions]
  );

  useEffect(() => {
    const params = new URLSearchParams();

    if (searchText) {
      params.set("query", searchText);
    }

    setSearchParams(params, {
      replace: true,
    });
  }, [setSearchParams, searchText]);

  return (
    <>
      <Box
        sx={{
          height: "60px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          p: "0px 24px",
          bgcolor: "#FFFFFF",
          borderBottom: "1px solid #E5E7EB",
        }}
      >
        {/* <Box sx={{ ml: "auto" }}>
          <LogoutContainer />
        </Box> */}
      </Box>
      <Box sx={HeaderStyle}>
        <Typography fontWeight="medium" color="text.primary">
          Users
        </Typography>

        {canEdit && (
          <Box sx={{ ml: "auto" }}>
            <Button
              variant="contained"
              startIcon={<Add />}
              onClick={() => setShowModal(true)}
            >
              New User
            </Button>
          </Box>
        )}
      </Box>
      <Box sx={{ p: 2.5, height: "calc(100vh - 132px)", overflow: "auto" }}>
        <UsersList
          searchText={searchText}
          showModal={showModal}
          setShowModal={setShowModal}
          setSearchText={setSearchText}
          canEdit={canEdit}
        />
      </Box>
    </>
  );
};

export default Users;
